import { render, staticRenderFns } from "./Requisiciones.vue?vue&type=template&id=e5ac1d36&scoped=true"
import script from "./Requisiciones.vue?vue&type=script&lang=js"
export * from "./Requisiciones.vue?vue&type=script&lang=js"
import style0 from "./Requisiciones.vue?vue&type=style&index=0&id=e5ac1d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ac1d36",
  null
  
)

export default component.exports